"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMergedCharacteristics = exports.characteristics = void 0;

var actions = _interopRequireWildcard(require("../actions/campaignCreator/loadCharacteristics"));

var _reselect = require("reselect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  isFetching: false,
  categories: []
};

var characteristics = function characteristics( // $FlowFixMe
state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.LOAD_CHARACTERISTICS_REQUEST:
      return _extends({}, state, {
        isFetching: true
      });

    case actions.LOAD_CHARACTERISTICS_FAILURE:
      return _extends({}, state, {
        isFetching: false
      });

    case actions.LOAD_CHARACTERISTICS_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        categories: action.payload
      });

    default:
      return state;
  }
};

exports.characteristics = characteristics;
var getMergedCharacteristics = (0, _reselect.createSelector)(function (state) {
  return state.characteristics;
}, function (items) {
  var newItems = items;
  newItems.categories.forEach(function (category, index) {
    var mainQuestions = [];
    category.questions.forEach(function (question, QuestionIndex) {
      //merge the questions with same question name
      if (typeof mainQuestions[question.questionLabel] === 'undefined') {
        var _mainQuestions$questi;

        //generate the default object used in items
        var temp = {
          questionId: question.questionId,
          questionLabel: question.questionLabel,
          answers: []
        };
        mainQuestions[question.questionLabel] = temp;

        (_mainQuestions$questi = mainQuestions[question.questionLabel].answers).push.apply(_mainQuestions$questi, question.answers);
      } else {
        var _mainQuestions$questi2;

        //push the duplicated category names into the one recently generated
        (_mainQuestions$questi2 = mainQuestions[question.questionLabel].answers).push.apply(_mainQuestions$questi2, question.answers);
      }
    }); //replace the default questions with the new one

    category.questions = Object.values(mainQuestions);
  });
  return newItems;
});
exports.getMergedCharacteristics = getMergedCharacteristics;